import React from 'react';
import PropTypes from 'prop-types';
import { IoDialogBasePropTypes } from './constants';
import { ConfirmDialog } from '../common';

export const BaseIoDialog = ({
  i18n,
  name,
  isShow,
  onConfirm,
  onCancel,
  title,
  content,
  confirmButtonText,
  cancelButtonText,
}) => (
  <ConfirmDialog
    name={name}
    isShow={isShow}
    onConfirm={onConfirm}
    onDecline={onCancel}
    title={title}
    content={content}
    confirmButtonText={confirmButtonText || i18n.getString(_TL_('Yes'))}
    declineButtonText={cancelButtonText || i18n.getString(_TL_('Cancel'))}
  />
);

BaseIoDialog.propTypes = {
  ...IoDialogBasePropTypes,
  name: PropTypes.string.isRequired,
  title: PropTypes.isRequired,
  content: PropTypes.oneOf([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  confirmButtonText: PropTypes.string.isRequired,
  cancelButtonText: PropTypes.string,
};

BaseIoDialog.defaultProps = {
  cancelButtonText: null,
};
